import { Config } from 'ha/config';
import FetchClient from 'ha/helpers/FetchClient';
import { Language } from 'ha/i18n/types';

import createTranslationService from './Translation';
import initFB from './initializers/initFB';
import fbService from './Facebook';
import googleMapApi from './GoogleMapApi';
import createApiV2 from './apiV2';
import makeSegmentService from './segment';
import algoliaService from './algolia';
import makeStripeService from './Stripe';
import makeTwilioService from './twilio';
import makeMonetaService from './moneta';
import makeOsirisService from './osiris';
import makeHermesService from './hermes';
import makeAlmanacService from './almanac';
import SplitIO from './SplitIO';

interface Clients {
  haApi: FetchClient;
  moneta: FetchClient;
  osiris: FetchClient;
  hermes: FetchClient;
  almanac: FetchClient;
  splitio: SplitIO;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  graphql: any;
  algolia: ReturnType<typeof algoliaService>;
}
interface AppServicesSetup {
  config: Config;
  clients: Clients;
  lang: Language;
}

function getAppServices({ config, clients, lang }: AppServicesSetup) {
  return {
    translation: createTranslationService(
      {
        languageDetectionURL: config.languageDetectionURL,
      },
      clients.haApi,
    ),
    graphql: clients.graphql,
    algolia: clients.algolia,
    facebook: fbService(() => initFB(config.facebook.client_id)),
    googleMapApi: googleMapApi({ key: config.google.maps_key, language: lang }),
    apiV2: createApiV2(clients.haApi),
    hermes: makeHermesService(clients.hermes),
    almanac: makeAlmanacService(clients.almanac, config.algolia.index),
    moneta: makeMonetaService(clients.moneta),
    osiris: makeOsirisService(clients.osiris),
    segment: makeSegmentService(config),
    stripe: makeStripeService(config),
    twilio: makeTwilioService(),
    splitio: clients.splitio,
  };
}

export type AppServices = ReturnType<typeof getAppServices>;

export default getAppServices;
